import useGgEnvironment from './useGgEnvironment';
import { isProd } from '../utils/environmentUtils';

export default function useIsProd(): boolean {
  const environment = useGgEnvironment();
  return isProd(environment);
}
